const data = {
    table: {
        columns: [
            {title: '类型', field: 'type', width: '150'},
            {title: '名称', field: 'name', width: '200'},
            {title: '创建时间', field: 'created', width: '180'},
            {title: '备注', field: 'remarks', width: ''}
        ],
        data: [],
        total: 0,
        page: 1,
        pageSize: 20
    }
}

export default data
